module.exports = __webpack_public_path__ + "static/apple-icon-120x120.e09d7d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-120x120.png
// module id = 597
// module chunks = 114276838955818